import axios from 'axios'

import { API_URL } from '@goodfellas/environment'

import { parseJwt } from '../functions/utils'

export const LOCAL_STORAGE_API_KEY = 'goodfellas:token'

export const goodfellasApi = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

const REDIRECT_PATH_UNAUTHORIZED = '/avaliacao'

goodfellasApi.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem(LOCAL_STORAGE_API_KEY)
    if (token) {
      // parseJwt returns null for a malformed token — destructuring it would
      // throw inside the interceptor and break every API request. Note: the
      // @goodfellas/jwt `exp` claim is in milliseconds, not Unix seconds.
      const payload = parseJwt(token)
      if (typeof payload?.exp !== 'number' || payload.exp < Date.now()) {
        localStorage.removeItem(LOCAL_STORAGE_API_KEY)
        return config
      }

      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  },
)

goodfellasApi.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    const isSessionCheck =
      error?.config?.url?.includes('/auth/session') ?? false
    const isSsoRoute =
      error?.config?.url?.includes('/authenticate/sso/') ?? false
    // Admin (dashboard) routes manage their own auth redirects (to /dashboard/login),
    // so they must not be hijacked by the global redirect to /avaliacao.
    const isAdminRoute = error?.config?.url?.includes('/admin/') ?? false
    if (
      error?.response?.status === 401 &&
      typeof window !== 'undefined' &&
      !isSessionCheck &&
      !isSsoRoute &&
      !isAdminRoute
    ) {
      localStorage.removeItem(LOCAL_STORAGE_API_KEY)
      goodfellasApi
        .post('/auth/logout')
        .catch(() => undefined)
        .finally(() => {
          window.location.replace(REDIRECT_PATH_UNAUTHORIZED)
        })
    }
    return Promise.reject(error)
  },
)
